import { http, inventoryService, practiceService, riskService, trainingService, workforceService } from '@/services'

let countKeys = (obj) => {
  var count = 0;
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      ++count;
    }
  }
  return count;
}

export const maps = {
  namespaced: true,
  state: {
    activityMap: {},
    inventoryMap: {},
    riskMap: {},
    roleMap: {},
    safeguardsMap: {},
    threatMap: {},
    trainingMap: {},
    workforceMap: {}
  },
  mutations: {
    activityMap: (state, map) => {
      state.activityMap = map;
    },
    inventoryMap: (state, map) => {
      state.inventoryMap = map;
    },
    riskMap: (state, map) => {
      state.riskMap = map;
    },
    roleMap: (state, map) => {
      state.roleMap = map;
    },
    safeguardsMap: (state, map) => {
      state.safeguardsMap = map;
    },
    threatMap: (state, map) => {
      state.threatMap = map;
    },
    trainingMap: (state, map) => {
      state.trainingMap = map;
    },
    workforceMap: (state, map) => {
      state.workforceMap = map;
    }
  },
  actions: {
    fetchActivityMap: ({ commit, state }) => {
      if (JSON.stringify(state.activityMap) != '{}') {
        return Promise.resolve(state.activityMap);
      }

      return practiceService.getActivityMap()
        .then(data => {
          commit('activityMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchInventoryMap: ({ commit, state }) => {
      if (JSON.stringify(state.inventoryMap) != '{}') {
        return Promise.resolve(state.inventoryMap);
      }

      return inventoryService.getInventoryMap()
        .then(data => {
          commit('inventoryMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchRiskMap: ({ commit, state }) => {
      if (JSON.stringify(state.riskMap) != '{}') {
        return Promise.resolve(state.riskMap);
      }

      return riskService.getRiskMap()
        .then(data => {
          commit('riskMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchRoleMap: ({ commit, state }) => {
      if (JSON.stringify(state.roleMap) != '{}') {
        return Promise.resolve(state.roleMap);
      }

      return workforceService.getRoleMap()
        .then(data => {
          data.AccessFullCount = countKeys(data.Access); // store full access count
          commit('roleMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchSafeguardsMap: ({ commit, state }) => {
      if (JSON.stringify(state.safeguardsMap) != '{}') {
        return Promise.resolve(state.safeguardsMap);
      }

      return riskService.getSafeguardsMap()
        .then(data => {
          commit('safeguardsMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchThreatMap: ({ commit, state }) => {
      if (JSON.stringify(state.threatMap) != '{}') {
        return Promise.resolve(state.threatMap);
      }

      return riskService.getThreatMap()
        .then(data => {
          commit('threatMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchTrainingMap: ({ commit, state }) => {
      if (JSON.stringify(state.trainingMap) != '{}') {
        return Promise.resolve(state.trainingMap);
      }

      return trainingService.getTrainingMap()
        .then(data => {
          commit('trainingMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    },
    fetchWorkforceMap: ({ commit, state }) => {
      if (JSON.stringify(state.workforceMap) != '{}') {
        return Promise.resolve(state.workforceMap);
      }

      return workforceService.getWorkforceMap()
        .then(data => {
          commit('workforceMap', data);
          return data;
        }, error => {
          return Promise.reject(error);
        });
    }
  }
}